var _style, _circle, _circle2, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFoooter2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191.4 40.9",
    style: {
      enableBackground: "new 0 0 191.4 40.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000105413216221823507000000002025103725270962099_);}\n\t.st3{fill:url(#SVGID_00000034776061652541855930000002723359776911813546_);}\n\t.st4{fill:url(#SVGID_00000081609904331673435970000018277133185256572562_);}\n\t.st5{fill:url(#SVGID_00000181079185332567397400000007395735239744520847_);}\n\t.st6{fill:url(#SVGID_00000078765457912028297490000011474180532328898973_);}\n\t.st7{fill:url(#SVGID_00000096041377137126574970000007563120666896271496_);}\n\t.st8{fill:url(#SVGID_00000093892242373529453490000007563228579325289870_);}\n\t.st9{fill:url(#SVGID_00000080917079710417170620000012140601948610554789_);}\n\t.st10{fill:url(#SVGID_00000016758949468762194250000012338320636209382809_);}\n\t.st11{fill:url(#SVGID_00000145751489286659351060000016447296835081175194_);}\n\t.st12{fill:url(#SVGID_00000181050140995971300950000009266733069274888322_);}\n\t.st13{fill:url(#SVGID_00000067217523216007555220000004275436717520428721_);}\n\t.st14{fill:url(#SVGID_00000071553975860234570090000007490724335676803492_);}\n\t.st15{fill:url(#SVGID_00000083790676373730191950000010746164288403688602_);}\n\t.st16{fill:url(#SVGID_00000018941094254714717540000014736648640141462662_);}\n\t.st17{fill:url(#SVGID_00000142151624075541327840000002040451941196958875_);}\n\t.st18{fill:url(#SVGID_00000088113285657246992940000007342445007965298861_);}\n\t.st19{fill:url(#SVGID_00000041281705035315075030000008708233299039473574_);}\n\t.st20{fill:url(#SVGID_00000181767842016425779520000009401143211837390267_);}\n\t.st21{fill:#1B75BB;}\n\t.st22{font-family:'AvenirNext-Bold';}\n\t.st23{font-size:39.645px;}\n\t.st24{opacity:0.12;}\n\t.st25{fill:url(#SVGID_00000176036792773539150270000006222885432559068094_);}\n\t.st26{fill:url(#SVGID_00000180361775776104146080000011698516903867847337_);}\n\t.st27{fill:url(#SVGID_00000031907676939072109100000010748617962031395989_);}\n\t.st28{fill:url(#SVGID_00000123421488165631662830000008843963526121673863_);}\n\t.st29{fill:url(#SVGID_00000173860025287305666470000004413197113622638992_);}\n\t.st30{fill:url(#SVGID_00000103252584868455440210000001656200316264691635_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 41.2,
    cy: 18.2,
    r: 14.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 64.4429,
    cy: 81.1448,
    r: 14.367,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -6.3784 -73.7026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#929497",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    style: {
      stopColor: "#949699",
      stopOpacity: 0.318
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#9B9DA0",
      stopOpacity: 0.4559
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7908,
    style: {
      stopColor: "#A8AAAC",
      stopOpacity: 0.5587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8828,
    style: {
      stopColor: "#B9BBBD",
      stopOpacity: 0.644
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8892,
    style: {
      stopColor: "#BBBDBF",
      stopOpacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBBDBF",
      stopOpacity: 0.95
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.4,
    cy: 18.2,
    r: 14.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088820494560909233310000008975469128609914770_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.6807,
    y1: 80.4516,
    x2: 81.3442,
    y2: 80.4516,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -6.3784 -73.7026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088820494560909233310000008975469128609914770_)"
    },
    d: "M41.1,0.5c0,0,13.5,0.9,16.7,12.5 c3.2,11.6-5,19.9-13.9,22.1c0,0,7.3-4.8,1.5-15.6l4.1-1.2c0,0,2-0.6,0.9-3.4c-1.1-2.7-1.3-3-1.3-3s-0.6-0.9-2.3-0.3 c-2.6,0.9-2.8,1.1-2.8,1.1S42.4,8.6,41.4,5C41,3.4,41,2.1,41.1,0.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032613113498997306090000013951863483336145290_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.1735,
    y1: 67.7365,
    x2: 72.2579,
    y2: 79.8209,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -6.3784 -73.7026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032613113498997306090000013951863483336145290_)"
    },
    d: "M40.2,6.6l2.3,7.7c0,0,3.4-1.1,4-1.4 c0.6-0.3,1.2,0.6,1.2,0.6s2.1,2.3,0.9,5.1c0,0,2.7-0.4,2-2.7c-0.8-2.7-1.7-4-1.7-4s-0.7-1-2.4-0.4c-2.2,0.8-2.8,1.2-2.8,1.2 l-2.7-9.4L40.2,6.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026850748540201007590000013576949309544763800_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.3561,
    y1: 89.6588,
    x2: 68.4948,
    y2: 89.6588,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -6.3784 -73.7026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026850748540201007590000013576949309544763800_)"
    },
    d: "M45.4,19.8c0,0,2.4,8-1.8,12.4 c-3,3.2,0.8,5.2,3.2-1C49.1,25.4,45.4,19.8,45.4,19.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183952747594377685770000009967369620491017628_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4005,
    y1: 81.6007,
    x2: 66.8584,
    y2: 81.6007,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -6.3784 -73.7026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183952747594377685770000009967369620491017628_)"
    },
    d: "M37.9,4.4c0,0-6.3,2.3-2.2,11.6 s7,12.8,4.7,19.2c0,0-14.2-0.3-16.5-14C21,4.6,37.1,0.6,37.2,0.9C37.2,1.2,37.9,4.4,37.9,4.4z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,12.7c0,0-2,5.9,5.9,14.1c0,0-3-0.7-3.5-1.7c0,0,0,1.1,0.6,2.1C31.7,27.2,25.4,21.2,28.8,12.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,22.7c0,0,2.2-5.8-5.4-14.3c0,0,2.9,0.8,3.4,1.9c0,0,0.1-1.1-0.5-2.1C53.1,8.1,59.2,14.3,55.6,22.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111189484549166517460000006674326219447244446_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.4461,
    y1: 81.1448,
    x2: 66.939,
    y2: 81.1448,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -6.3784 -73.7026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111189484549166517460000006674326219447244446_)"
    },
    d: "M37.2,0.9c0,0-7.7,6.3-1.9,15.4 s5.4,18.2,5.4,18.2s3-4.7-4.7-19.3c0,0-3.8-7.3,1.9-10.8L37.2,0.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143599054156738217300000017531867802561776545_",
    cx: 41.3383,
    cy: 39.8344,
    r: 8.3224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07491276,
    style: {
      stopColor: "#BBBDBF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2894,
    style: {
      stopColor: "#BEC0C2",
      stopOpacity: 0.4033
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    style: {
      stopColor: "#C6C8CA",
      stopOpacity: 0.4695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5427,
    style: {
      stopColor: "#D5D7D8",
      stopOpacity: 0.5253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    style: {
      stopColor: "#EAEBEC",
      stopOpacity: 0.575
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6588,
    style: {
      stopColor: "#EDEEEF",
      stopOpacity: 0.5812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    style: {
      stopColor: "#EBEAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EAEB"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000143599054156738217300000017531867802561776545_)"
    },
    cx: 41.3,
    cy: 39.8,
    rx: 11.8,
    ry: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2.4664 34.5241)",
    className: "st21 st22 st23"
  }, "F    RTUNE"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFoooter2);
export default __webpack_public_path__ + "static/media/logo-foooter2.1c85bd66dd445d57854961bbf2a543fe.svg";
export { ForwardRef as ReactComponent };